export default "__VITE_PUBLIC_ASSET__9b9658d7__"